<script lang="ts">
	import { onMount } from "svelte";

	export let url: string;

	let videoElement: HTMLVideoElement;

	onMount(() => {
		const handleKeydown = (event: KeyboardEvent) => {
			if (event.code === "Space") {
				event.preventDefault();
				if (videoElement.paused) {
					videoElement.play();
				} else {
					videoElement.pause();
				}
			}
		};
		window.addEventListener("keydown", handleKeydown);
		return () => {
			window.removeEventListener("keydown", handleKeydown);
		};
	});
</script>

<video
	bind:this={videoElement}
	src={url}
	controls
	width="100%"
	class="video-player-container"
	data-testid="video-player"
>
	<track kind="captions" src="" srclang="en" label="English captions" />
</video>

<style>
	.video-player-container {
		max-height: 80vh;
		object-fit: contain;
		background-color: black;
		border-radius: 4px;
	}
</style>
